import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import EditDamages from './edit-damages';
import EditTires from './edit-tires';
import { useEditTransaction } from './edit-transaction.context';
import EditGeneral from './general-information';
import EditTrucking from './trucking-information';

import { Loader } from 'components';
import ErrorDialog from 'components/organization/dialog/error-dialog';
import '../transaction-details.scss';
import EditImages from './edit-images';
import './edit.scss';

const EditTransactionForm: FC = () => {
  const navigate = useNavigate();
  const { didSubmit, formRef, transactionId, transaction, handleSubmit } = useEditTransaction();

  const handleReset = useCallback(() => {
    if (!transactionId) navigate('/transactions', { replace: true });
    else navigate(`/transactions/${transactionId}`, { replace: true });
  }, [transactionId, navigate]);

  if (!transactionId) return null;

  return (
    <form className="page" id="edit-transaction" onReset={handleReset} onSubmit={handleSubmit} ref={formRef}>
      <div className="page-header">
        <div className="d-flex g-3">
          <h1>TRANSACTION #{transactionId}</h1>
          {!transaction?.inbound ? (
            <label className="status gate-out">GATE OUT</label>
          ) : (
            <label className="status gate-in">GATE IN</label>
          )}
          {transaction?.bulk && <label className="status bulk">BULK</label>}
        </div>
        <div className="d-flex g-3">
          <button className="btn-outline col-start-3" type="reset">
            CANCEL
          </button>
          <Loader loading={didSubmit}>
            <button className="btn-primary col-start-4" type="submit">
              SUBMIT
            </button>
          </Loader>
        </div>
      </div>
      <div className="page-content overflow-auto">
        <EditGeneral />
        <EditImages />
        <EditTrucking />
        <EditDamages />
        <EditTires />
      </div>
      <ErrorDialog />
    </form>
  );
};

export default EditTransactionForm;
